export default {
  firebase_error_codes: {
    'auth/email-already-in-use': 'Diese E-Mail-Adresse wird bereits von einem anderen Konto benutzt.',
    'auth/operation-not-allowed': 'Es ist nicht möglich, sich bei diesem Projekt mit einem Passwort einzuloggen.',
    'auth/too-many-requests': 'Wegen ungewöhnlich hoher Aktivität haben wir alle Anforderungen von diesem Gerät blockiert. Versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
    'auth/user-not-found': 'Dieser Benutzer ist uns nicht bekannt.',
    'auth/wrong-password': 'Dieses Passwort ist ungültig.',
    'auth/user-disabled': 'Dieses Benutzerkonto wurde von einem Administrator gesperrt.',
    'auth/expired-action-code': 'Der Kennwortrücksetzungscode ist abgelaufen.',
    'auth/invalid-action-code': 'Der Kennwortrücksetzcode ist ungültig. Code ist fehlerhaft oder wurde bereits verwendet.',
    'auth/user-token-expired': 'Der Token dieses Benutzers ist nicht mehr gültig. Der Benutzer muss sich wieder einloggen.',
    'auth/invalid-user-token': 'Der Refresh-Token ist ungültig.',
    'auth/invalid-credential': 'Der angegebene Grant-Type ist ungültig.',
    'auth/invalid-verification-code': 'Phone-Code eingeben',
  },
  authentication: {
    form: {
      phone: {
        label_text: 'Mobiltelefonnummer',
        additional_label_text: 'Kein SMS-Code? Erneut versuchen',
        additional_label_mobile_text: 'Kein SMS-Code?',
      },
      email: {
        label_text: 'Email',
        placeholder_text: 'ihre@email.com',
        is_invalid_text: 'Geben Sie eine gültige Email-Adresse ein.',
        label_email_text: 'Ihre E-Mail-Adresse',
      },
      password: {
        label_text: 'Passwort',
        additional_label_text: 'Passwort vergessen?',
        placeholder_text: 'Geben Sie ein Passwort ein',
        is_invalid_text: 'Geben Sie ein gültiges Passwort ein.',
      },
      sign_in: {
        button_text: 'Anmelden',
        button_text_before_send_SMS: 'Phone-Code anfordern',
      },
      reset_password: {
        button_text: 'Passwort anfordern',
      },
      set_new_password: {
        button_text: 'Passwort setzen',
      },
    },
  },
  navigation: {
    vehicles: 'Fahrzeuge',
    buyers: 'Käufer',
    profile: 'Profil',
    sms_campaign: 'Massenversand',
    contacts: 'Kontakte',
    reports: 'Berichte',
    purchased: 'Gekauft',
  },
  view_titles: {
    sign_in_title_text: 'Melden Sie sich mit Ihren Zugangsdaten an.',
    sign_in_title_small_text: 'Falls Sie noch kein Konto besitzen, senden Sie Ihre Anfrage an info@autodrop.ch',
    reset_password_title_text: 'Um das Passwort zurückzusetzen, geben Sie Ihre E-Mail-Adresse ein.',
    set_new_password_title_text: 'Legen Sie unten ein neues Passwort fest.',
    dashboard_title_text: 'Alle Fahrzeuge',
    dashboard_purchased_title_text: 'Alle gekaufte Fahrzeuge',
    buyer_title_text: 'Käufer',
    user_profile_title_text: 'Profil',
    add_vehicle_title_text: 'Fahrzeug hinzufügen',
    edit_vehicle_title_text: 'Fahrzeug bearbeiten',
    add_buyer_title_text: 'Käufer hinzufügen',
    bids_view_title_text: 'Gebote',
    sms_campaign_title_text: 'Massenversand',
    add_sms_campaign_title_text: 'Massenversand hinzufügen',
    edit_sms_campaign_title_text: 'Massenversand bearbeiten',
    contacts_title_text: 'Kontakte',
    add_contact_list_title_text: 'Kontaktliste hinzufügen',
    contacts_list_title_text: 'Kontaktliste',
    add_contact_title_text: 'Kontakt hinzufügen',
    vehicle_preview_title_text: 'Fahrzeugvorschau',
    team_members_title_text: 'Team',
    reports_title_text: 'Berichte',
    reports_add_title_text: 'Bericht hinzufügen',
    vehicle_main_image_text: 'Hauptbild',
  },
  buyer_group: {
    form: {
      name: {
        label: 'Käufergruppe name',
        placeholder: 'zum Beispiel: BMW Käufergruppe',
      },
      error_message: 'Geben Sie einen Gruppennamen ein',
    },
    list: {
      no_buyer_list: 'Noch keine Käufergruppe',
      buyer_list_not_available_for_the_slave_account: 'Bitte wenden Sie sich an Ihren Vorgesetzten, wenn Sie einen neuen Käufer vorschlagen möchten',
    },
  },
  loading_status: {
    wait: 'Bitte warten...',
  },
  buyer: {
    form: {
      name: {
        label: 'Name',
        placeholder: 'Name eingeben',
      },
      phone_number: {
        label: 'Telefonnummer',
        placeholder: 'CH oder DE Handynummer',
      },
      email_address: {
        label: 'Email',
        placeholder: 'E-Mail eingeben',
      },
      description: {
        label: 'Anmerkungen',
        placeholder: 'Anmerkungen',
      },
      loading_label: '@:loading_status.wait',
      error_messages: {
        name: 'Geben Sie einen Namen ein',
        phone_number: 'Geben Sie eine gültige Telefonnummer ein',
      },
    },
    list: {
      main_title: 'Käufer',
      singular_label: 'Käufer',
      plural_label: 'Käufer',
      no_buyers: 'Noch keine Käufer',
    },
    add: {
      main_title: 'Käufer hinzufügen',
    },
    edit: {
      main_title: 'Käufer speichern',
    },
    delete: {
      main_action: 'Löschen',
      cancel: 'Abbrechen',
      main_title: 'Möchten Sie wirklich dieser Käufer löschen?',
    },
  },
  user_profile: {
    my_account_text: 'Mein Konto',
    sign_out_text: 'Ausloggen',
    support_text: 'Unterstützung',
    change_name_label_text: 'Vor-und Nachname',
    change_name_placeholder_text: 'Neuen Namen eingeben',
    add_name: 'Bitte geben Sie Ihren Namen ein',
    add_company_name: 'Bitte geben Sie Ihr Firma ein',
    change_company_name: 'Firmaname',
    change_password_placeholder_text: 'Geben Sie Ihr neues Passwort ein',
    error_message_username_text: 'Geben Sie einen Namen ein.',
    error_message_incorrect_address: 'Bitte geben Sie die korrekte Adresse an',
    error_message_new_username_text: 'Geben Sie einen neuen Namen ein.',
    select_language_label_text: 'Bevorzugte Sprache',
    select_language_placeholder_text: 'Wählen Sie Ihre bevorzugte Sprache',
    language_saved_text: 'Sprache gespeichert',
    name_saved_text: 'Ihr Name wurde gespeichert',
    password_saved_text: 'Ihr Passwort wurde gespeichert',
    address_saved_text: 'Ihre Adresse wurde gespeichert',
    type_cars_saved_text: 'Ihr Fahrzeugtyp wurde gespeichert',
    option_saved_text: 'Option gespeichert',
    additional_options_text_seller: 'Zusätzliche Einstellungen',
    additional_options_text_buyer: 'Ich interessiere mich für',
    allow_bid_deletion_label_text: 'Erlauben Sie dem Käufer, sein Gebot zu löschen',
    allow_bid_modification_label_text: 'Erlauben Sie dem Käufer, sein Gebot zu ändern',
    bidding_completion_email_label: 'Email nach dem Verkauf',
    option_car: 'PKW',
    option_truck: 'LKW',
    option_car_truck: 'LKW und PKW',
    add_address_field_label: 'Bitte fügen Sie Ihre Adresse hinzu',
    change_address_field_placeholder: 'Bitte geben Sie Ihre neue Adresse ein',
    change_address_field_label: 'Adressänderung',
    change_address_field_text: 'Sind Sie sicher, dass Sie Ihre Adresse aktualisieren möchten?',
    change_password_field_label: 'Ihr Passwort ändern',
    verified_phone_number: 'Ihre Telefonnummer',
  },
  buyers_view: {
    buyers_pool_text: 'Käufergruppen',
    add_buyer_text: 'Käufer hinzufügen',
    confirm_buyer_delete_text: 'Möchten Sie diesen Käufer wirklich löschen?',
    empty_list_text: 'Es gibt keine Käufer in dieser Käufergruppe',
  },
  sms_campaign_view: {
    sms_campaign_active_text: 'SMS Massenversand - Aktiv',
    sms_campaign_archived_text: 'SMS Massenversand - Archiviert',
    sms_campaign_starting_date_text: 'Anfangsdatum: ',
    add_sms_campaign_text: 'Massenversand hinzufügen',
    sms_campaign_delete_text: 'Möchten Sie diese SMS-Kampagne wirklich löschen?',
    sms_campaign_status_draft_text: 'Entwurf',
    sms_campaign_status_ready_to_send_text: 'Bereit zum Senden',
    sms_campaign_status_archived_text: 'Archiviert',
    sms_campaign_status_in_progress_text: 'Wird gesendet',
  },
  contacts_view: {
    title_text: 'Kontaktliste',
    add_list_text: 'Liste hinzufügen',
    confirm_list_delete_text: 'Möchten Sie diese Liste wirklich löschen?',
  },
  contacts_list_view: {
    add_contact_text: 'Kontakt hinzufügen',
    confirm_contact_delete_text: 'Möchten Sie diesen Kontakt wirklich löschen?',
    more_contacts_text: 'Es gibt mehr Kontakte...',
  },
  vehicle_expired: {
    expired_text: 'Dieses Angebot ist abgelaufen',
    wait_another_offer_or_visit_link: 'Warten Sie auf das nächste Angebot oder besuchen Sie',
    interested_in_more_offers_text: 'Bist du an mehr Fahrzeugangebote interessiert?',
    more_about_text: 'Erfahre mehr unter',
    your_last_offer_was: 'Ihr letztes Gebot war',
  },
  contact_list_form: {
    list_name_text: 'Listennamen',
    list_name_placeholder_text: 'Listennamen eingeben',
    add_list_text: 'Liste hinzufügen',
  },
  contact_form: {
    first_name_text: 'Vorname',
    first_name_placeholder_text: 'Vorname eingeben',
    last_name_text: 'Nachname',
    last_name_placeholder_text: 'Nachname eingeben',
    phone_number_text: 'Telefonnummer',
    phone_number_placeholder_text: 'Telefonnummer eingeben',
    add_contact_text: 'Kontakt hinzufügen',
  },
  sms_campaign_form: {
    sms_campaign_name_text: 'Name',
    sms_campaign_name_placeholder_text: 'Name eingeben',
    sms_campaign_date_text: 'Anfangsdatum',
    sms_campaign_starting_time_text: 'Startzeit: ',
    sms_campaign_message_placeholder_text: 'Schreibe deine Nachricht',
    sms_campaign_message_length_text: 'Nachrichtenlänge: ',
    sms_campaign_save_message_text: 'Nachricht speichern',
    fetching_list_text: 'Bitte warten...',
  },
  dashboard: {
    add_vehicle_text: 'Erfassen',
    vehicle_status_text: {
      active_vehicle_default_text: 'Laufende',
      archived_vehicle_default_text: 'Abgelaufene',
      extended_text: 'Fahrzeuge',
      shorthand_text: 'FZ',
      active_vehicle_extended_text: '@:dashboard.vehicle_status_text.active_vehicle_default_text @:dashboard.vehicle_status_text.extended_text',
      active_vehicle_shorthand_text: '@:dashboard.vehicle_status_text.active_vehicle_default_text @:dashboard.vehicle_status_text.shorthand_text',
      archived_vehicle_extended_text: '@:dashboard.vehicle_status_text.archived_vehicle_default_text @:dashboard.vehicle_status_text.extended_text',
      archived_vehicle_shorthand_text: '@:dashboard.vehicle_status_text.archived_vehicle_default_text @:dashboard.vehicle_status_text.shorthand_text',
    },
    no_active_vehicle_text: 'Keine laufende Fahrzeuge.',
    no_archived_vehicle_text: 'Keine Fahrzeuge gefunden.',
    highest_bid_text: 'Höchstes Gebot:',
    no_bids_text: 'Keine Gebote',
    vehicle_card_text: {
      online_in_text: 'Online in',
      days_text: 'Tag | Tage',
      online_today_text: 'Online Heute',
    },
  },
  vehicle_form: {
    select_at_least_one_buyer_group: 'Wählen Sie mindestens eine Käufergruppe aus.',
    unsaved_changes: 'Sie haben ungespeicherte FZ Daten, möchten Sie wirklich die Seite verlasssen?',
    make_placeholder_text: 'Wählen Sie eine Marke aus',
    model_placeholder_text: 'Wählen Sie ein Modell aus',
    version_placeholder_text: 'FZ Version eingeben',
    mileage_placeholder_text: 'Kilometerstand eingeben',
    body_type_placeholder_text: 'Wählen Sie eine Aufbauart',
    registration_date_placeholder_text: 'Datum auswählen',
    last_inspection_date_placeholder_text: 'Datum auswählen',
    fuel_type_placeholder_text: 'Wählen Sie den Treibstoff',
    gear_type_placeholder_text: 'Wählen Sie die Schaltart',
    engine_power_placeholder_text: 'Geben Sie die Motorleistung ein',
    engine_capacity_placeholder_text: 'Geben Sie die Hubraum ein',
    notes_placeholder_text: 'Zusätzliche Bemerkungen',
    select_vehicle_card_id_text: 'Auswählen',
    to_image_upload_text: 'Zum Hochladen von Bildern',
    select_images_text: 'Bilder auswählen',
    selected_images_text: 'Bilder vom Fahrzeug',
    image_upload_hint_1_text: 'Sie können auch die Bilder vom Serviceheft / Fahrzeugbewertung (Eurotax, Auto-i-dat) hochladen.',
    image_upload_hint_2_text: 'Um den besten Preis zu erhalten, empfehlen wir 7-10 Bilder hochzuladen.',
    back_to_details_text: 'Zurück zu den Details',
    add_vehicle_text: 'Fahrzeug senden',
    save_vehicle_text: 'Fahrzeug speichern',
    extras_text: 'Eigenschaften (Optional)',
    internal_number_placeholder_text: 'z.B. letzte 8 Ziff. von dem Chassis Nr.',
    loading_images_text: 'Bilder werden geladen',
    vehicle_data_title: 'Fahrzeugdaten',
    buyer_pool_collapse_title: 'Käufergruppen',
    available_right_away_text: 'ab Sofort',
    choose_date_text: 'Datum auswählen',
  },
  vehicle_details: {
    valid_until_text: 'Online bis',
    mfk_text: 'Letzte MFK',
    place_your_bid_text: 'Gebot abgeben',
    modify_your_bid_text: 'Gebot anpassen',
    confirm_button_text: 'Bestätigen',
    cancel_button_text: 'Abbrechen',
    remove_your_bid_text: 'Gebot stornieren',
    remove_your_bid_question_text: 'Remove your bid question',
    open_document_text: 'Dokument öffnen',
    is_no_warranty_explanation_text: 'Jede Gewährleistung, soweit nach Gesetz möglich, wird wegbedungen. Insbesondere sind Wandelung und Minderung ausgeschlossen.',
    vehicle_text_scheduled: 'Geplant für online am',
    is_checked_text: 'Ja',
    is_not_checked_text: 'Nein',
    bid_is_too_low_text: 'Ihr Gebot ist zu tief, bieten Sie einen höheren Betrag an.',
    enter_your_bid_first_text: 'Geben Sie Ihr Gebot in',
    enter_your_bid_last_text: 'ein (zum Beispiel: 7500).',
    your_bid_is_text: 'Ihr Gebot ist',
    confirm_bid_text: 'Möchten Sie wirklich ein Gebot für dieses Fahrzeug abgeben?',
    available_right_away_text: 'Sofort',
    error_message_buyer_name: 'Um Gebote für Autos abzugeben, aktualisieren Sie bitte Ihren Namen und Ihre Adresse unter dem "Profil". Sobald die Adresse des Namens festgelegt ist, schauen Sie bitte hier noch einmal nach',
  },
  to_contact_form_text: 'Zum Kontaktformular',
  home_view: {
    welcome_text: 'Willkommen auf AutoDrop!',
    sell_car_per_sms_text: 'Verkaufen Sie Ihre Fahrzeuge per SMS',
    thanks_for_email_text: 'Vielen Dank für Ihre Anfrage. Wir werden schnellstmöglich auf Sie zukommen.',
    want_know_more_text: 'Möchten Sie mehr über AutoDrop erfahren?',
    enter_email_placeholder_text: 'Geben Sie Ihre Email Adresse ein',
    send_email_button_text: 'Absenden',
    already_have_account_text: 'Haben Sie schon ein AutoDrop Konto?',
    to_login_button_text: 'zur Anmeldung',
    enter_valid_name_text: 'Geben Sie eine gültige Name an.',
    enter_valid_phone_text: 'Geben Sie eine gültige Telefon an.',
    enter_valid_email_text: 'Geben Sie eine gültige Email Adresse an.',
    price_text: 'Preise',
    login_text: 'Anmelden',
    b2b_title_text: 'B2B-Auktionsplattform für Eintausch- und Gebrauchtfahrzeuge',
    subtitle_long_text: 'Auf Autodrop können Autohändler Ihre Fahrzeuge bequem uploaden und per SMS/WhatsApp zum Verkauf anbieten. Ausgewählte Käufergruppen erhalten von geprüften Händlern Angebote und geben Ihren besten Preis ab.',
    subtitle_short_text: 'Die Lösung für eine Win-Win Situation im Autohandel!',
    buy_vehicle_title_text: 'Fahrzeuge Kaufen',
    buy_vehicle_subtitle_text: 'Erhalten Sie Fahrzeuge von geprüften Händlern per SMS/WhatsApp und bieten Sie Ihren besten Preis an.',
    read_more_text: 'Mehr erfahren',
    read_more_route_name: 'SellerInformationDE',
    sell_vehicle_title_text: 'Fahrzeuge Verkaufen',
    sell_vehicle_subtitle_text: 'Auktionieren Sie ihre Fahrzeuge per SMS/WhatsApp an ausgewählte Autohändler',
    contact_form_title_text: 'Kontaktformular',
    i_want_to_text: 'Ich möchte',
    i_want_to_buy_vehicle_text: 'Fahrzeuge kaufen',
    i_want_to_sell_vehicle_text: 'Fahrzeuge verkaufen',
    i_want_to_buy_vehicle_new_text: 'Falls Sie Autos kaufen möchten, melden Sie sich einfach',
    i_want_to_buy_vehicle_new_link_text: 'hier an',
    name_placeholder_text: 'Andreas Meyer',
    company_name_placeholder_text: 'Firma AG/GmbH',
    phone_placeholder_text: 'CH oder DE Handynummer',
    email_placeholder_text: 'ihre@email.com',
    name_label_text: 'Name',
    company_name_label_text: 'Geschäftsname',
    phone_label_text: 'Natel',
    phone_second_label_text: 'mit SMS/WhatsApp',
    email_label_text: 'Email',
    advantages_text: 'Vorteile',
    first_advantage_text: 'Erfassen Sie ihr Fahrzeug in nur einer Minute mit ihrem Handy.',
    second_advantage_text: 'Sie erhalten in ~30 Minuten einen ersten, realen Marktpreis.',
    third_advantage_text: 'Transparenz in der gesamten Verkaufseinheit des Autohauses.',
    last_offers_text: 'Letzte Fahrzeuge von unserem B2B Markt',
    choose_checkbox: 'Bitte wählen Sie aus, ob Sie Autos verkaufen oder kaufen möchten!',
  },
  buyer_read_more_view: {
    steps_for_buying_vehicle_title_text: 'Deine Schritte zum Fahrzeugkauf',
    first_step_title_text: 'Kontaktformular',
    first_step_explanation_text: 'Möchtest du bequem von überall an Fahrzeug-Auktionen teilnehmen? Dann fülle unser Kontaktformular aus und werde Teil der AutoDrop Käufergruppe. Die Mitgliedschaft ist kostenlos!',
    second_step_title_text: 'Verkaufsangebote',
    second_step_explanation_text: 'Erhalte Verkaufsangebote von vertrauenswürdigen Autohändlern per SMS. Im beigefügten Link findest du Fotos mit detaillierten Beschreibungen der Fahrzeuge.',
    third_step_title_text: 'Angebot',
    third_step_explanation_text: 'Interessiert? Dann gib innerhalb von 24 Stunden dein bestes Angebot ab! Du kannst dein Gebot jederzeit erhöhen. Jedes Angebot sollte realistisch sein und ist verbindlich.',
    fourth_step_title_text: 'Kauf',
    fourth_step_explanation_text: 'War dein Angebot das Beste, kontaktiert dich der Autohändler telefonisch oder per E-Mail um die nächsten Schritte zu besprechen',
  },
  seller_read_more_view: {
    steps_for_selling_vehicle_title_text: 'Deine Schritte zum Fahrzeug Verkauf',
    first_step_title_text: 'Mitgliedschaft',
    first_step_explanation_text: 'Fülle unser Kontaktformular aus und erhalte deinen persönlichen Autodrop-Account.',
    second_step_title_text: 'Käufergruppe',
    second_step_explanation_text: 'Nutze unsere Käufergruppe oder erstelle deine eigene nach eigenen Kriterien (Nähe, Vertrauen, etc.).',
    third_step_title_text: 'Auktion',
    third_step_explanation_text: 'Sobald dein Fahrzeug erfasst ist, erhält die Käufergruppe eine SMS und kann innerhalb von 24 Stunden Gebote abgeben, die du jederzeit verfolgen kannst. Diese Angebote sind nur für dich sichtbar, um Absprachen zu vermeiden.',
    fourth_step_title_text: 'Verkauf',
    fourth_step_explanation_text: 'Kontaktiere den Käufer mit dem besten Angebot, um die nächsten Schritte zu besprechen. Unverkaufte Fahrzeuge werden archiviert und können jederzeit erneut versteigert werden. Du bist frei, neue Käufer zu deiner Liste hinzuzufügen, um deine Chancen zu verbessern.',
  },
  price_list_view: {
    price_intro_title_text: 'Faire und unkomplizierte Preise',
    price_intro_subtitle_text: 'Wir haben die tiefsten Kosten für den Gebrauchwagenverkauf',
    free_tryout_subtitle_text: 'Erfassen sie einen Monat lang kostenlos so viele Fahrzeuge wie Sie möchten. Sie bezahlen nur die SMS Gebühren.',
    sms_fee_title_text: 'Gebühr pro SMS',
    sms_fee_subtitle_text: 'SMS werden an potenzielle Käufer versendet.',
    upload_vehicle_title_text: 'Gebühr pro Fahrzeug',
    upload_vehicle_subtitle_text: 'Sie zahlen nur, wenn ein FZ auf Autodrop veröffentlicht wird.',
    monthly_bill_explanation_text: 'Am Ende jedes Monats erhalten Sie eine Rechnung mit einer Auflistung aller Käufe per Email.',
    buyer_text: 'Käufer',
    seller_text: 'Verkäufer',
    signin_seller_text: 'Verkäufer',
    signin_buyer_text: 'Käufer',
    free_auto_drop_text: 'AutoDrop Konto',
    free_auto_drop_subtitle_text: 'Alle Leistungen sind für Käufer kostenlos.',
    logo_title_text: 'Eigenes Logo (Optional)',
    logo_subtitle_text: 'Einmalige Einrichtungsgebühr',
    own_sender_name_title_text: 'Eigener Absendername (Optional)',
    own_sender_name_subtitle_first_text: 'Einmalige Einrichtungsgebühr, danach 10',
    own_sender_name_subtitle_last_text: 'pro Monat',
    whatsapp_title_text: 'AutoDrop für WhatsApp',
    whatsapp_subtitle_first_text: '10',
    whatsapp_subtitle_last_text: 'pro Monat',
    more_questions_text: 'Haben Sie noch Fragen?',
    phone_text: 'Telefon',
    free_text: 'Kostenlos',
  },
  vehicle_preview: {
    version_label_text: 'Version',
    make_label_text: 'Marke',
    model_label_text: 'Modell',
    enginePower_label_text: 'Motorleistung',
    engineCapacity_label_text: 'Hubraum',
    availableFrom_label_text: 'Verfügbar ab',
    bodyType_label_text: 'Aufbauart',
    fuelType_label_text: 'Treibstoff',
    gearboxType_label_text: 'Schaltart',
    isNoWarranty_label_text: 'Ab Platz / Ohne Garantie',
    isServiceDone_label_text: 'Service gepflegt',
    isSummerWinterTyreSetAvailable_label_text: '8-fach bereift',
    isTwoKeysAvailable_label_text: '2. FZ Schlüssel',
    isFourWheelDrive_label_text: 'Allrad (4x4)',
    isVehicleNotReadyToDrive_label_text: 'FZ ist nicht fahrbar',
    mileage_label_text: 'Kilometerstand',
    notes_label_text: 'Anmerkungen',
    bids_title_text: 'Gebote',
    no_bids_title_text: 'Noch keine Gebote',
    vehicle_details_title_text: 'Fahrzeugdetails',
    vehicle_send_again_text: 'Möchten Sie dieses Fahrzeug erneut senden?',
    vehicle_send_again_button_text: 'Erneut Senden',
    vehicle_send_again_cancel_button_text: 'Abbrechen',
    vehicle_send_again_warning_text: 'Möchtest du dieses Fahrzeug erneut an alle Käufer versenden? Bitte beachte, dass die SMS-Kosten verrechnet werden.',
    bidding_ends_in_text: 'Endet in',
    internalNumber_label_text: 'Wagen-Nr.',
    call_the_highest_bidder_text: 'Kontaktieren Sie bitte den Höchstbietenden, um die Geschäftsabwicklung durchzuführen.',
    created_on_text: 'Erfasst am',
    statistics_text: 'Statistiken',
    visits_text: 'Besuche',
  },
  reports: {
    report_type_option_vehicles: 'Fahrzeuge',
    report_type_option_sellers: 'Verkäufer',
    report_name_label_text: 'Berichtsname',
    report_name_placeholder_text: 'Geben Sie die Berichtnamen ein',
    report_start_date_label_text: 'Startdatum',
    report_start_date_placeholder_text: 'Wählen Sie das Startdatum aus',
    report_end_date_label_text: 'Enddatum',
    report_end_date_placeholder_text: 'Wählen Sie das Enddatum aus',
    report_type_label_text: 'Berichtstyp auswählen',
    report_type_placeholder_text: 'Wählen Sie den Berichtstyp aus',
    report_save_button_text: 'Bericht speichern',
    report_download_button_text: 'Herunterladen',
    your_first_report_text: 'Fügen Sie Ihren ersten Bericht hinzu',
    generating_report_text: 'Wird generiert..',
    report_type_sellers_text: 'Verkäufer',
    report_type_vehicles_text: 'Fahrzeuge',
    delete_report_question_text: 'Möchten Sie diesen Bericht löschen?',
    delete_report_cancel_button_text: 'Abbrechen',
    delete_report_confirm_delete_button_text: 'Löschen',
    reports_initial_loading_text: 'Laden',
    reports_add_title_text: 'Bericht hinzufügen',
    generation_failed: 'Die Generierung ist fehlgeschlagen.',
  },
  // NEW fields
  actions: {
    add: 'Hinzufügen',
    back_to_vehicles: 'Zurück zu Fahrzeuge',
    edit: 'Bearbeiten',
    reload_page: 'Neu laden',
    save: 'Speichern',
    show: 'Anzeigen',
  },
  bids: {
    plural_rules: 'Gebot | Gebote',
    ends: 'Endet',
    starts: 'Startet',
  },
  buyer_group_new: {
    // Note: https://kazupon.github.io/vue-i18n/guide/pluralization.html#pluralization
    plural_rules: 'Käufergruppe | Käufergruppen',
    global: {
      plural_rules: 'Autodrop gruppe | Autodrop gruppen',
    },
    owned: {
      plural_rules: 'Persönliche gruppe | Persönliche gruppen',
    },
    actions: {
      add: 'Käufergruppe @.lower:(actions.add)',
      edit: 'Käufergruppe @.lower:(actions.edit)',
      confirm_deletion: 'Möchten Sie wirklich diese Käufergruppe löschen?',
    },
  },
  error: {
    loading: 'Fehler beim Laden, versuchen Sie es später noch einmal.',
  },
  form: {
    select_value: 'Auswählen',
    enter_value: 'Wert eingeben',
    optional_label: '- Optional',
  },
  not_allowed: {
    to_see_this_type_of_vehicle: 'Es ist Ihnen nicht erlaubt, diesen Fahrzeugtyp zu sehen.',
    to_see_vehicle: 'Es ist Ihnen nicht erlaubt, dieses Fahrzeug zu sehen.',
  },
  online: 'Online',
  short: {
    cubic_centimetre: 'ccm',
    horsepower: 'PS',
    kilowatt: 'kW',
  },
  status: {
    selected: {
      plural_rules: 'ausgewählt',
    },
    none_selected: 'Keine ausgewählt',
  },
  vehicle: {
    plural_rules: 'Fahrzeug | Fahrzeuge',
    localized_data_order: ['vehicle.plural_rules', 'data'],
    localized_photos_order: ['vehicle.plural_rules', 'photos'],
    available_from: 'Verfügbar ab',
    axe_type: 'Achskonfiguration',
    body_type: 'Aufbauart',
    emission_type: 'Abgasnorm',
    engine_capacity: 'Hubraum',
    engine_capacity_ccm: 'Hubraum (@:(short.cubic_centimetre))',
    engine_power: 'Leistung',
    engine_power_kw: 'Motorleistung (@:(short.kilowatt))',
    fuel_type: 'Treibstoff',
    gearbox_type: 'Schaltart',
    general_condition: 'Allgemeinzustand',
    id_document: 'Fahrzeugausweis',
    interior: 'Innenraum',
    internal_number: 'Wagen-Nr.',
    last_inspection_date: 'MFK Datum',
    make: 'Marke',
    mileage: 'Kilometerstand',
    model: 'Modell',
    notes: 'Anmerkungen',
    notes_optional: 'Anmerkungen (Optional)',
    registration_date: 'Inverkehrsetzung',
    tachometer: 'Tacho',
    tires_condition: 'Reifenzustand',
    valid_until: 'Gültig bis',
    version: 'Version/Typ',
    actions: {
      add: 'Fahrzeug @.lower:(actions.add)',
      edit: 'Fahrzeug @.lower:(actions.edit)',
      save: 'Fahrzeug @.lower:(actions.save)',
    },
    options: {
      four_wheel_drive: 'Allrad (4x4)',
      no_warranty: 'Ab Platz / Ohne Garantie',
      not_ready_to_drive: 'FZ ist nicht fahrbar',
      summer_winter_tyre_set_available: '8-fach bereift',
      service_done: 'Service gepflegt',
      two_keys_available: '2. FZ Schlüssel',
    },
    status: {
      is_being_sent: 'Wird gesendet',
    },
  },
  front: 'Vorne',
  back: 'Hinten',
  left: 'Links',
  right: 'Rechts',
  main_picture: 'Hauptbild',
  data: 'Daten',
  photos: 'Bilder',
  publication_date: 'Veröffentlichungsdatum',
  round: 'Runde',
  sending_options: 'Versandoptionen',
  active: {
    plural_rules: 'Laufende | Laufende',
  },
  archived: {
    plural_rules: 'Archiviert | Archivierte',
  },
  no_vehicles_created_yet: 'Sie haben noch keine Fahrzeuge erstellt.',
  no_vehicles_yet: 'Sie haben noch keine Fahrzeuge.',
  no_archived_vehicles: 'Sie haben keine Archivierte Fahrzeuge.',
  no_vehicles_for_buyer: 'Im Moment haben wir keine Fahrzeuge, sorry  :(',
  update_button_text: 'zum Profil',
  need_help_button_text: 'Brauchst du Support?',
  no_active_and_name_buyer_text: 'Ihr Konto ist noch nicht aktiv, bitte geben Sie Ihren Namen und Ihre Adresse an, damit wir es überprüfen können. Wir werden Sie benachrichtigen, sobald es bereit ist!',
  no_active_buyer_text: 'Dein Konto ist in der Prüfung.',
  no_confirmed_purchased_vehicles: 'Gekaufte Fahrzeuge werden hier angezeigt, nachdem der Verkäufer den Verkauf bestätigt hat',
  all_vehicles: 'Alle Fahrzeuge',
  create_vehicle: 'Erfassen',
  vehicle_is_being_added: 'Fahrzeug wird hinzugefügt..',
  vehicle_is_being_saved: 'Fahrzeug wird gespeichert..',
  language_display_names: {
    de: 'Deutsch',
    fr: 'Französisch',
    en: 'Englisch',
  },
};
